<template>
    <div class="big_box">
        <div class="header_warpper">
            <div class="left">
                <el-form
                    :model="form"
                    :rules="computedRules"
                    ref="ruleForm"
                    label-position="top"
                    :inline="true"
                    style="display: flex; justify-content: space-between"
                >
                    <template v-for="(item, index) in allArr.item">
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :label="item.item_name"
                            style=""
                            :key="index"
                            v-if="(item.type == 'select' || item.type == 'select-multiple') && item.status == 1"
                        >
                            <el-select
                                size="mini"
                                v-model="form[item.item_no]"
                                filterable
                                clearable
                                @clear="handleClear(item)"
                                :multiple="item.type == 'select-multiple'"
                                @change="changeData(item, item.type)"
                                default-first-option
                                :placeholder="'请选择' + item.item_name"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="option in allArr.value[item.item_no.replace('_no', '')] || []"
                                    :key="option[item.item_no.replace('_no', '') + '_no']"
                                    :label="`${option[item.item_no.replace('_no', '') + '_no']} - ${
                                        option[item.item_no.replace('_no', '') + '_name']
                                    }`"
                                    :value="option[item.item_no.replace('_no', '') + '_no']"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :label="item.item_name"
                            style=""
                            :key="index"
                            v-else-if="(item.type == 'number' || item.type == 'text') && item.status == 1"
                        >
                            <el-input
                                v-model="form[item.item_no]"
                                :type="item.type"
                                :placeholder="'请输入' + item.item_name"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :label="item.item_name"
                            v-else-if="item.type == 'switch' && item.status == 1"
                            :key="index"
                            style=""
                        >
                            <el-tag :type="form[item.item_no] == '1' ? 'success' : form[item.item_no] == '0' ? 'danger' : ''">{{
                                form[item.item_no] == 1 ? '是' : '否'
                            }}</el-tag>
                            <el-switch style="margin-left: 5px" v-model="form[item.item_no]" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </el-form-item>
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :key="index"
                            :label="item.item_name"
                            style=""
                            v-else-if="item.status == 1 && ['date', 'datetime', 'daterange', 'datetimerange'].includes(item.type)"
                        >
                            <el-date-picker
                                v-bind="getDatePickerProps(item)"
                                v-model="form[item.item_no]"
                                @blur="(value) => getTimes(value, item)"
                                @change="(value) => changeTime(value, item)"
                            />
                        </el-form-item>
                    </template>
                </el-form>
            </div>
            <div class="right">
                <!-- <el-button @click="freshen">{{ $t('common.refresh') }}</el-button> -->
                <el-button @click="searchIt">{{ $t('common.search') }}</el-button>
                <el-button @click="outExcel">{{ $t('common.export') }}</el-button>
            </div>
        </div>
        <template>
            <div>
                <div style="display: flex; margin-top: 10px">
                    <div style="background: white; flex: 4; padding: 20px; border-radius: 8px">
                        <div class="inbound" style="display: flex; justify-content: space-between">
                            <p style="font-size: 14px" @click="shouinbound = !shouinbound" class="title">
                                汇总表
                                <i class="el-icon-caret-right" v-if="!shouinbound"></i>
                                <i class="el-icon-caret-bottom" v-else></i>
                            </p>
                            <div>
                                <el-button @click="changeTable(dtlArrTotal.head)" icon="el-icon-setting"></el-button>
                            </div>
                        </div>

                        <template>
                            <div class="selectTableBoxTotal" v-show="shouinbound">
                                <el-table
                                    border
                                    
                                    height="250"
                                    :data="dtlArrTotal.data"
                                    style="width: 100%; margin-top: 5px; font-size: 14px"
                                    :summary-method="(param) => getSummaries(param, dtlArrTotal, systemSet)"
                                    show-summary
                                    :key="refushTable"
                                >
                                    <template slot="empty">
                                        <div style="display: flex; justify-content: center; align-items: center; height: 250px">
                                            <img src="@/assets/img/dontHave.png" alt="" style="width: 250px; height: 250px" />
                                        </div>
                                    </template>
                                    <el-table-column
                                        v-for="(item, index) in dtlArrTotal.head"
                                        :key="index"
                                        :prop="item.field"
                                        :label="item.title"
                                        :width="item.field == 'seq' ? 50 : 160"
                                        :align="item.field == 'seq' ? 'center' : 'left'"
                                        :sortable="item.issort == 1"
                                        v-if="item.status == 1"
                                        :sort-method="(a, b) => a[item.field] - b[item.field]"
                                    >
                                        <!-- 使用 v-slot 定义插槽内容 -->
                                        <template v-slot="scope">
                                            <!-- 针对 bill_no 列的特殊渲染 -->
                                            <div v-if="item.field == 'bill_no'">
                                                <el-button type="text" @click="handleDetails(scope.row)">
                                                    {{ scope.row.bill_no }}
                                                </el-button>
                                            </div>
                                            <!-- 默认渲染其他列 -->
                                            <div v-else>
                                                {{ scope.row[item.field] }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="selectTableBox">
                <div style="display: flex; justify-content: space-between">
                    <p style="font-size: 14px">明细</p>
                    <div>
                        <el-button @click="changeTable(dtlArrDtl.head)" icon="el-icon-setting"></el-button>
                    </div>
                </div>
                <el-table
                    border
                    
                    height="550"
                    :data="dtlArrDtl.data"
                    style="width: 100%; margin-top: 5px; font-size: 14px"
                    :summary-method="(param) => getSummaries(param, dtlArrDtl, systemSet)"
                    show-summary
                >
                    <template slot="empty">
                        <div style="display: flex; justify-content: center; align-items: center; height: 550px">
                            <img src="@/assets/img/dontHave.png" alt="" style="width: 250px; height: 250px" />
                        </div>
                    </template>
                    <el-table-column
                        v-for="(item, index) in dtlArrDtl.head"
                        :key="index"
                        :prop="item.field"
                        :label="item.title"
                        :width="item.field == 'seq' ? 50 : 160"
                        :align="item.field == 'seq' ? 'center' : 'left'"
                        :sortable="item.issort == 1"
                        v-if="item.status == 1"
                        :sort-method="(a, b) => a[item.field] - b[item.field]"
                    >
                        <!-- 使用 v-slot 定义插槽内容 -->
                        <template v-slot="scope">
                            <!-- 针对 bill_no 列的特殊渲染 -->
                            <div v-if="item.field == 'bill_no'">
                                <el-button type="text" @click="handleDetails(scope.row)">
                                    {{ scope.row.bill_no }}
                                </el-button>
                            </div>
                            <!-- 默认渲染其他列 -->
                            <div v-else>
                                {{ scope.row[item.field] }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="form.page"
                        :page-size="form.page_size"
                        :page-sizes="[100, 200, 300, pageTotal]"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                        @size-change="page_sizeChange"
                    ></el-pagination>
                </div>
            </div> </template
        ><el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false">
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.title }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.status == 0"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.title }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { apitotalTable, apitotalTablePull, apitotalTableExport, apiGetListCorrespondingReportData } from '@/request/api';
export default {
    name: 'totaltable',
    data() {
        let self = this; // 加上这句改变this就可以了
        return {
            tableScrollTopTotal: 0, // 汇总表滚动位置
            tableScrollTopDtl: 0,   // 明细表滚动位置
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            missingFields: '',
            shouinbound: true,
            mulStyle: '',
            outData_IsShow: false,
            tabPosition: 'today',

            dtlArrTotal: [],
            dtlArrDtl: [],
            allArr: '',
            title_name: '',
            form: {
                billDate: new Date(),
                page: 1,
                page_size: 10,
                style:[]
            },
            pageTotal: 0,
            perData: '',
            systemSet: JSON.parse(localStorage.getItem('systemSet')),
            dateTime: '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            if (self.tabPosition !== 'today') {
                                self.tabPosition = 'today'; // 设置tab位置为今天
                            }
                            const end = new Date();
                            const start = new Date();
                            start.setHours(0, 0, 0, 0); // 设置开始时间为今天的00:00:00
                            end.setHours(23, 59, 59, 999); // 设置结束时间为今天的23:59:59
                            self.dateTime = [start, end]; // 更新 dateTime
                            picker.$emit('pick', [start, end]); // 触发选中的日期范围
                        }
                    },
                    {
                        text: '昨日',
                        onClick(picker) {
                            if (self.tabPosition !== 'zuori') {
                                self.tabPosition = 'zuori'; // 设置tab位置为昨日
                            }
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24); // 设置为昨日的时间
                            start.setHours(0, 0, 0, 0); // 设置开始时间为昨日的00:00:00
                            end.setHours(23, 59, 59, 999); // 设置结束时间为昨日的23:59:59
                            self.dateTime = [start, end]; // 更新 dateTime
                            picker.$emit('pick', [start, end]); // 触发选中的日期范围
                        }
                    },
                    {
                        text: '本月',
                        onClick(picker) {
                            if (self.tabPosition !== 'benyue') {
                                self.tabPosition = 'benyue'; // 设置tab位置为本月
                            }
                            let currentDate = new Date();
                            let currentMonth = currentDate.getMonth();
                            let currentYear = currentDate.getFullYear();
                            const start = new Date(currentYear, currentMonth, 1); // 本月第一天
                            const end = new Date(currentYear, currentMonth + 1, 0); // 本月最后一天
                            end.setHours(23, 59, 59, 999); // 设置结束时间为本月的最后一秒
                            self.dateTime = [start, end]; // 更新 dateTime
                            picker.$emit('pick', [start, end]); // 触发选中的日期范围
                        }
                    },
                    {
                        text: '上月',
                        onClick(picker) {
                            if (self.tabPosition !== 'shangyue') {
                                self.tabPosition = 'shangyue'; // 设置tab位置为上月
                            }
                            let currentDate = new Date();
                            let currentMonth = currentDate.getMonth();
                            let currentYear = currentDate.getFullYear();

                            // 如果当前月份是1月（即0月），则上个月是去年12月
                            if (currentMonth === 0) {
                                currentMonth = 11; // 上个月是12月
                                currentYear--; // 年份减1
                            } else {
                                currentMonth--; // 上个月
                            }
                            const start = new Date(currentYear, currentMonth, 1); // 上月第一天
                            const end = new Date(currentYear, currentMonth + 1, 0); // 上月最后一天
                            end.setHours(23, 59, 59, 999); // 设置结束时间为上月的最后一秒
                            self.dateTime = [start, end]; // 更新 dateTime
                            picker.$emit('pick', [start, end]); // 触发选中的日期范围
                        }
                    }
                ]
            }
        };
    },
    deactivated() {
        // 保存汇总表滚动位置
        const totalTableBody = document.querySelector('.selectTableBoxTotal .el-table__body-wrapper');
        if (totalTableBody) {
            this.tableScrollTopTotal = totalTableBody.scrollTop;
        }

        // 保存明细表滚动位置
        const detailTableBody = document.querySelector('.selectTableBox .el-table__body-wrapper');
        if (detailTableBody) {
            this.tableScrollTopDtl = detailTableBody.scrollTop;
        }
    },
    activated() {
        this.$nextTick(() => {
            // 恢复汇总表滚动位置
            const totalTableBody = document.querySelector('.selectTableBoxTotal .el-table__body-wrapper');
            if (totalTableBody) {
                totalTableBody.scrollTop = this.tableScrollTopTotal;
            }

            // 恢复明细表滚动位置
            const detailTableBody = document.querySelector('.selectTableBox .el-table__body-wrapper');
            if (detailTableBody) {
                detailTableBody.scrollTop = this.tableScrollTopDtl;
            }
        });
    },
    watch: {},
    created() {
        this.getPull();
    },
    computed: {
        // 动态计算表单验证规则
        computedRules() {
            const rules = {};
            // 遍历 allArr.item，根据 ismust 为 1 的项来动态生成验证规则
            if (this.allArr.item) {
                this.allArr.item.forEach((item) => {
                    // console.log(item, 'item有值没有啊');
                    if (item.ismust == 1) {
                        if (['date', 'datetime', 'daterange', 'datetimerange'].includes(item.type)) {
                            rules[item.item_no] = [{ required: true, message: `请选择${item.item_name}`, trigger: 'change' }];
                        } else if (['select', 'switch'].includes(item.type)) {
                            rules[item.item_no] = [{ required: true, message: `请选择${item.item_name}`, trigger: 'change' }];
                        } else {
                            rules[item.item_no] = [
                                {
                                    required: true,
                                    message: `${item.item_name}不能为空`,
                                    trigger: 'blur'
                                }
                            ];
                        }
                    }
                });
            }

            return rules;
        }
    },
    methods: {
        //列配置相关接口
        changeTable(data) {
            this.drawers = true;
            this.keyList = data;
        },
        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'status', '1');
            }
        },
        checkMove(item) {},
        keycancel() {
            this.drawers = false;
            this.getData();
        },
        keyConfirm() {
            // let keyList = JSON.stringify(this.keyList);
            if (this.keyList) {
                apiGetListCorrespondingReportData({
                    head: this.keyList
                }).then((res) => {
                    this.drawers = false;
                    if (res.code == 2000) {
                        this.$message.success(res.msg);
                        this.refushTable = !this.refushTable;
                    } else if (res.code == 4000) {
                        this.$message.warning(res.data.info);
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            }
        },
        getDatePickerProps(item) {
            const baseProps = {
                style: 'width: 99%',
                placeholder: '选择' + item.item_name
            };
            switch (item.type) {
                case 'date':
                    return {
                        ...baseProps,
                        type: 'date',
                        valueFormat: 'yyyy-MM-dd'
                    };
                case 'datetime':
                    return {
                        ...baseProps,
                        type: 'datetime',
                        valueFormat: 'yyyy-MM-dd HH:mm:ss'
                    };
                case 'daterange':
                    return {
                        ...baseProps,
                        type: 'daterange',
                        valueFormat: 'yyyy-MM-dd',
                        startPlaceholder: '开始日期',
                        endPlaceholder: '结束日期',
                        defaultTime: ['00:00:00', '23:59:59'],
                        pickerOptions: this.pickerOptions
                    };
                case 'datetimerange':
                    return {
                        ...baseProps,
                        type: 'datetimerange',
                        valueFormat: 'yyyy-MM-dd HH:mm:ss',
                        startPlaceholder: '开始日期',
                        endPlaceholder: '结束日期',
                        defaultTime: ['00:00:00', '23:59:59'],
                        pickerOptions: this.pickerOptions
                    };
                default:
                    return {};
            }
        },

        //刷新
        freshen() {
            // console.log(this.missingFields, 'this.missingFields');
            if (Array.isArray(this.missingFields)) {
                // 使用 every 来检查 missingFields 中的每个字段是否在 this.form 中有值
                const allFieldsHaveValue = this.missingFields.every((field) => {
                    // 检查 form 中是否有该字段，且字段的值不为空
                    return this.form && this.form[field] && this.form[field] !== '';
                });

                if (allFieldsHaveValue) {
                    this.searchIt();
                } else {
                    this.getPull();
                }
            }
            this.freSplit();
        },
        freSplit() {
            if (this.mulStyle) {
                // 如果 this.mulStyle 是 Set
                this.mulStyle.forEach((key) => {
                    let value = this.form[key];
                    // console.log(value, 'vallue');
                    // 如果 value 是字符串类型，进行 split 操作
                    if (typeof value == 'string') {
                        // console.log(this.form[key], 'this.form[key]');
                        if (value) {
                            // 将字符串按逗号拆分成数组
                            this.form[key] = value.split(',');
                        }
                    }
                });
            }
        },
        // 跳转订购列表
        handleDetails(row) {
            if (row.allow_use == '0') {
                this.$message.error('暂无权限');
            } else {
                if (row.bill_code) {
                    this.$router.push({
                        path: '/' + row.bill_code,
                        query: {
                            bill_no: row.bill_no
                        }
                    });
                }
            }
        },
        changeTime(val, row) {
            // console.log(val, row.item_no, 'changeTime');
            if (val == null || val.length === 0) {
                // 如果时间为空，显示错误消息并设为今天
                // this.$message.error('时间不能为空,已默认为当天');
                setTimeout(() => {
                    // 默认时间为今天的开始和结束时间
                    const today = this.formatDate(new Date());
                    this.form[row.item_no] = [today, today]; // 设定日期范围
                    this.dateTime = [today, today]; // 更新单一日期的数组
                    this.tabPosition = 'today'; // 切换到今天的标签
                    // this.searchIt(); // 执行搜索操作
                }, 500);
            } else {
                // 如果时间有值，清空 tabPosition
                this.tabPosition = '';
            }
        },
        // 获取时间的选择结果
        getTimes(event, row) {
            // console.log(event, row, 'getTimes');
            if (!this.form[row.item_no]) {
                // 如果没有初始化，设置为一个空数组
                this.$set(this.form, row.item_no, []);
            }
            // 更新日期范围值
            if (event && event.displayValue && event.displayValue.length === 2) {
                this.form[row.item_no] = [event.displayValue[0], event.displayValue[1]]; // 设定日期范围
            }
        },
        formatDate(date) {
            if (!date) return ''; // 如果 date 是 null 或 undefined，返回空字符串或一个默认值
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            if (month < 10) {
                month = `0${month}`;
            }
            if (day < 10) {
                day = `0${day}`;
            }
            return `${year}-${month}-${day}`;
        },
        handleClick(tab, row) {
            // console.log(tab, tab.name, row, 'tab,row,e');

            this.form.billDate = this.formatDate(new Date());
            // 判断 row 和 allArr.item 是否存在
            if (!row || !this.allArr.item || this.allArr.item.length === 0) {
                return; // 如果没有必要的参数则直接返回
            }

            // 遍历 allArr.item 来检查是否每个必填字段都在 row 中
            let missingFieldsData = []; // 用来存储缺失的字段
            let missingFields = []; // 用来存储缺失的字段
            this.allArr.item.forEach((item) => {
                // 不需要包裹在数组中，直接遍历 this.allArr.item
                if (item.ismust == 1) {
                    // 如果该字段是必填项
                    const fieldName = item.item_no; // 获取字段名
                    const fieldValue = row[fieldName]; // 获取 row 中对应字段的值

                    // 判断 row 中是否存在该字段，并且该字段值不为空
                    if (!fieldValue || fieldValue == '' || fieldValue == null || (Array.isArray(fieldValue) && fieldValue.length == 0)) {
                        missingFieldsData.push(item.item_name); // 如果缺失，添加到 missingFieldsData 数组
                        missingFields.push(item.item_no);
                    }
                }
            });
            this.missingFields = missingFields;
            // console.log(
            //     missingFields,
            //     missingFieldsData,
            //     missingFields.filter((field) => field !== 'billDate'),
            //     'missingFields'
            // );
            // 如果有缺失的字段，弹出提示框
            if (missingFieldsData.length > 0 && missingFields.filter((field) => field !== 'billDate').length > 0) {
                this.outData_IsShow = true;
                const missingFieldsStr = missingFieldsData.join(', '); // 将缺失的字段名拼接成字符串
                this.$message.error(`以下字段是必选项，请填写或选择${missingFieldsStr}`);
            } else {
                // 执行搜索操作
                this.searchIt();
            }
        },
        getPull() {
            this.$load.show();
            apitotalTablePull({}).then((res) => {
                this.$load.close();
                if (res.code == 2000) {
                    this.allArr = res.data;
                    this.title_name = res.module;
                    this.handleClick('today', this.allArr);
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        handleClear(item) {
            // console.log('Cleared:', item.item_no);
            // 清空后的逻辑
            this.form[item.item_no] = ''; // 或者其他适当的处理方式
        },
        changeData(row, e) {
            if (e == 'select-multiple') {
                // 使用 Set 来确保无重复项
                if (!this.mulStyle) {
                    this.mulStyle = new Set();
                }

                this.mulStyle.add(row.item_no);
            }
            // console.log(row.item_no, e, 'jkjjj');
        },
        searchIt() {
            this.form.page = 1;
            this.form.page_size = 100;
            if (this.mulStyle) {
                // 如果 this.mulStyle 是 Set
                this.mulStyle.forEach((key) => {
                    let value = this.form[key];
                    // console.log(value, 'vallue');
                    // 如果 value 是字符串类型，进行 split 操作
                    if (typeof value == 'string') {
                        // console.log(this.form[key], 'this.form[key]');
                        if (value) {
                            // 将字符串按逗号拆分成数组
                            this.form[key] = value.split(',');
                        }
                    }
                });
            }
            // console.log(this.form, 'this.form');
            this.getData();
        },
        // 确认筛选-------------------------------------------------
        getData() {
            let data = this.form;
            Object.keys(data).forEach((key) => {
                if (Array.isArray(data[key]) && data[key].length === 0) {
                    delete data[key]; // 删除空数组字段
                } else if (data[key] === '') {
                    delete data[key]; // 删除空字符串字段
                }
            });
            // console.log(this.form, 'this.form');

            // 遍历 this.mulStyle 中的每个键，并处理相应的数据字段
            if (this.mulStyle) {
                this.mulStyle.forEach((key) => {
                    if (Array.isArray(data[key])) {
                        // 如果 data[key] 是数组，转换为逗号分隔的字符串
                        data[key] = data[key].join(',');
                    }
                });
            }

            // console.log(data, 'updated data');

            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$load.show();
                    apitotalTable(data).then((res) => {
                        if (res.code == 2000) {
                            this.outData_IsShow = false;
                            this.dtlArrTotal = res.data.汇总;
                            this.dtlArrDtl = res.data.明细;
                            this.pageTotal = res.data.汇总.count;
                            this.$message.success(res.msg);
                            this.$load.close();
                        } else {
                            this.dtlArrTotal = [];
                            this.dtlArrDtl = [];
                            this.pageTotal = 0;
                            this.outData_IsShow = false;
                            this.$message.error(res.data.info);
                            this.$load.close();
                        }
                        this.freSplit();
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            // this.$load.close();
        },
        //合并的公共方法

        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.form.page = val;
            this.getData();
        },
        page_sizeChange(val) {
            this.form.page = 1;
            this.form.page_size = val;
            this.getData();
        },
        //导出摸版
        outExcel() {
            this.$load.show();
            this.form.login_staff = localStorage.getItem('ms_username');
            this.form.is_exports = 1;
            let data = JSON.parse(JSON.stringify(this.form))
            if(Array.isArray(data.style)){
                data.style = data.style.join(',')
            }
            apitotalTableExport(data)
                .then((res) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([res.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.title_name + '.xlsx';
                    link.click();
                    this.form.is_exports = 0;
                    this.$load.close();
                })
                .catch((error) => {
                    console.error('API Request Failed:', error); // 错误处理
                    this.$load.close();
                });
        },
        getSummaries(param, dtlArr, systemSet) {
            const { columns, data } = param;
            const sums = [];
            let dtlArrData = dtlArr.head;

            columns.forEach((column, index) => {
                if (index === 0) {
                    // 如果是第一列，可以设置为 "合计" 或其它值
                    sums[index] = '合计';
                    return;
                }

                // 过滤出需要计算合计的数据行
                const filteredData = dtlArrData.filter((item) => item.issum == 1);
                // 获取当前列需要合计的字段数据
                const columnData = filteredData.map((item) => item.field);

                // 如果该列字段在数据中找到对应的字段，则进行合计计算
                if (columnData.includes(column.property)) {
                    // 获取当前列的所有数据并进行处理
                    const columnDataValues = data.map((item) => {
                        // 将值转换为字符串，避免 replace 报错
                        let value = item[column.property] || '0';
                        value = value.toString().replace(/,/g, ''); // 转换为字符串并去掉千位分隔符
                        return Number(value); // 转换为数字用于合计
                    });

                    // 计算合计
                    if (!columnDataValues.every((value) => isNaN(value))) {
                        sums[index] = columnDataValues.reduce((prev, curr) => {
                            return isNaN(curr) ? prev : prev + curr;
                        }, 0);
                    } else {
                        sums[index] = ''; // 如果没有有效数据，则不显示合计
                    }

                    let decimalPlaces = 0; // 默认不保留小数
                    // 映射 fmtnum 到对应的小数位数
                    const fmtnumToDecimalPlaces = {
                        qty: systemSet.qty,
                        amt: systemSet.amt,
                        rate: systemSet.rate,
                        wgt: systemSet.wgt
                    };

                    // 查找匹配字段并直接获取小数位数
                    filteredData.forEach((item) => {
                        if (item.field == column.property) {
                            decimalPlaces = fmtnumToDecimalPlaces[item.fmtNum] || 0; // 默认值为 0
                        }
                    });

                    // 保留小数位，并格式化为千位分隔符
                    if (sums[index] !== '') {
                        sums[index] = sums[index].toFixed(decimalPlaces); // 保留小数位
                        const [integerPart, decimalPart] = sums[index].split('.');
                        const withCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        sums[index] = decimalPart ? `${withCommas}.${decimalPart}` : withCommas;
                    }
                }
            });

            return sums;
        }
    }
};
</script>

<style lang="scss" scoped>
.big_box {
    // background: #fff;
    // padding: 20px;
}
.header_warpper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 25px;
    height: 50px;
    .left {
        display: flex;
        align-items: center;
    }
}
/deep/.el-tabs__nav-wrap::after {
    background-color: #fff;
}
/deep/.el-tabs__item {
    width: 66px;
    text-align: center;
    padding: 0;
    font-size: 12px;
}
/deep/.el-tabs__active-bar {
    width: 66px !important;
}
.selectTableBox {
    background: #fff;
    padding: 20px;
    margin-top: 10px;
    // 合计行样式
    /deep/ .has-gutter tr td .cell:empty::before {
        // content: '';
    }
    /deep/ .el-table__footer-wrapper tbody td,
    .el-table__header-wrapper tbody td {
        // background-color: #e3f3ff !important;
    }
    /deep/ .el-table__footer-wrapper .is-leaf {
        // background-color: #e3f3ff !important;
    }
    /deep/ .el-table__fixed-footer-wrapper tbody td {
        // border-top: 1px solid #ebeef5;
        // background-color: #e3f3ff;
        // font-weight: bold;
        color: #f50b0b;
        // text-align: center !important;
    }
    /deep/ .has-gutter tr td .cell {
        // text-align: center;
        font-weight: bold;
        color: #f50b0b;
    }

    /deep/ .el-table {
        display: flex;
        flex-direction: column;
    }

    /* order默认值为0，只需将表体order置为1即可移到最后，这样合计行就上移到表体上方 */
    /deep/ .el-table__body-wrapper {
        order: 0;
    }

    // 若没有固定列，以下代码可以不写
    // 将固定列放在首行
    /deep/ .el-table__fixed-body-wrapper {
        // top: 96px !important; // 根据自己的项目进行微调
    }

    /deep/ .el-table__fixed-footer-wrapper {
        font-weight: bold;
        // z-index: 0;
        // top: 48px; // 根据自己的项目进行微调
    }
}
.selectTableBoxTotal {
    background: #fff;
    margin-top: 10px;
    // 合计行样式
    /deep/ .has-gutter tr td .cell:empty::before {
        // content: '';
    }
    /deep/ .el-table__footer-wrapper tbody td,
    .el-table__header-wrapper tbody td {
        // background-color: #e3f3ff !important;
    }
    /deep/ .el-table__footer-wrapper .is-leaf {
        // background-color: #e3f3ff !important;
    }
    /deep/ .el-table__fixed-footer-wrapper tbody td {
        // border-top: 1px solid #ebeef5;
        // background-color: #e3f3ff;
        // font-weight: bold;
        color: #f50b0b;
        // text-align: center !important;
    }
    /deep/ .has-gutter tr td .cell {
        // text-align: center;
        font-weight: bold;
        color: #f50b0b;
    }

    /deep/ .el-table {
        display: flex;
        flex-direction: column;
    }

    /* order默认值为0，只需将表体order置为1即可移到最后，这样合计行就上移到表体上方 */
    /deep/ .el-table__body-wrapper {
        order: 0;
    }

    // 若没有固定列，以下代码可以不写
    // 将固定列放在首行
    /deep/ .el-table__fixed-body-wrapper {
        // top: 96px !important; // 根据自己的项目进行微调
    }

    /deep/ .el-table__fixed-footer-wrapper {
        font-weight: bold;
        // z-index: 0;
        // top: 48px; // 根据自己的项目进行微调
    }
}
.inbound {
    width: 100%;
    background-color: #fff;
    .title {
        cursor: pointer;
        i {
            color: #409eff;
        }
    }
}
</style>
